import { render, staticRenderFns } from "./EditObjectItem.vue?vue&type=template&id=6d02b99c&"
import script from "./EditObjectItem.vue?vue&type=script&lang=js&"
export * from "./EditObjectItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports